var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('navbar',{attrs:{"data":_vm.item,"user":_vm.user,"type":'edit',"isAuth":_vm.isAuth},on:{"reload":_vm.reload}}),_vm._v(" "),(_vm.item)?_c('datatable',{ref:"datatable",attrs:{"customer":_vm.item,"isAuth":_vm.isAuth,"user":_vm.user}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00d03d67","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/components/customers/views/html/Requests.html
// module id = null
// module chunks = 